/*
 *   File : text-button.js
 *   Author : https://evoqins.com
 *   Description : text button component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { memo } from 'react';
import { Icon } from '../Icon';

const TextButton = (props) => {
    return (
        <span className={`${props.className ?? ""} ${props.fontSize ?? "e-font-14"}  ${props.fontWeight ?? "e-font-weight-600"} e-text-indigo e-alt-font-noto-sans   line-height-20px text-decoration-hover-underline cursor-pointer`}
            onClick={props.onPress}>
            {props.name}
            {props.icon === true &&
                <Icon icon="arrow" className="ms-2" height={12} width={6} />
            }
        </span>
    )
}

export default memo(TextButton);